var Recognition;
(function (Recognition) {
    Recognition["ErrUnknown"] = "PBRECUnkown";
    Recognition["ErrInvalidArguments"] = "PBRECInvalidArguments";
    Recognition["ErrNotEnoughPeople"] = "PBRECNotEnoughPeople";
    Recognition["ErrNotFound"] = "PBRECNotFound";
    Recognition["ErrUnauthorized"] = "PBRECUnauthorized";
    Recognition["ErrAlreadyExists"] = "PBRECAlreadyExists";
    Recognition["ErrDBPing"] = "PBRECDBPing";
})(Recognition || (Recognition = {}));
export default Recognition;
